import {createListCollection, HStack, Icon, Portal, Select} from "@chakra-ui/react";
import {HiOutlineGlobeAsiaAustralia} from "react-icons/hi2";
import {useState} from "react";

const LNG_MOCKUP_COLLECTION = createListCollection({
    items: [
        {
            value: "pl-PL",
            label: "Polski",
        },
        {
            value: "en-US",
            label: "English",
        },
        {
            value: "de-DE",
            label: "Deutsch",
        },
    ],
})

const LanguageSelector = () => {
    const [language, setLanguage] = useState(["pl-PL"]);

    return (
        <HStack w={'100%'} px={3}>
            <Icon size={'lg'} color={'text.user'}>
                <HiOutlineGlobeAsiaAustralia />
            </Icon>
            <Select.Root
                collection={LNG_MOCKUP_COLLECTION}
                value={language}
                size={"sm"}
                onValueChange={(e) => setLanguage(e.value)}
            >
                <Select.HiddenSelect />
                <Select.Control>
                    <Select.Trigger>
                        <Select.ValueText placeholder="Select language" color={"text.user"} />
                    </Select.Trigger>
                    <Select.IndicatorGroup>
                        <Select.Indicator />
                    </Select.IndicatorGroup>
                </Select.Control>
                <Portal>
                    <Select.Positioner>
                        <Select.Content>
                            {LNG_MOCKUP_COLLECTION.items.map((language) => (
                                <Select.Item item={language} key={language.value} color={"text.user"} >
                                    {language.label}
                                    <Select.ItemIndicator />
                                </Select.Item>
                            ))}
                        </Select.Content>
                    </Select.Positioner>
                </Portal>
            </Select.Root>
        </HStack>
    )
}

export default LanguageSelector;